<template>
  <v-col
    :class="{
      'get-lower': !$vuetify.breakpoint.mdAndUp,
      'pa-0': true,
      fullScreen: true,
      fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
    }"
    cols="12"
  >
    <CommonDialog
      :dialog="dialogDeleteOne"
      :head-text="$t('documents.delete-title')"
      :content-text="$t('documents.delete-dialog')"
      :confirm-button="{
        text: $t('documents.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :on-confirm="deleteDocument"
      :on-cancel="setDocumentToDelete"
    ></CommonDialog>
    <DialogForMassOperators
      :dialog.sync="dialogMove"
      :loading.sync="loading"
      :head-text="$t('documents.choose-folder')"
      :confirm-button="{
        text: $t('documents.move'),
        icon: 'mdi-arrow-expand-right'
      }"
      :selected="selected"
      v-on:update:selected="updateSelected"
      :destinations="folders"
      destination-label="documents.folder"
      permission="document.update"
      dispatch="documentStore/massMove"
      :isWillRemove="true"
      :on-success="updateDocumentList"
      permissions-item-key="_folder"
    ></DialogForMassOperators>
    <DialogForMassUpdate
      :dialog.sync="dialogUpdate"
      :loading.sync="loading"
      :selected="selected"
      v-on:update:selected="updateSelected"
      :destinations="folders"
      destination-label="documents.folder"
      permission="document.update"
      dispatch="documentStore/massMove"
      :isWillRemove="true"
      :on-success="updateDocumentList"
      permissions-item-key="_folder"
    ></DialogForMassUpdate>
    <DialogForMassOperators
      :dialog.sync="dialogCopy"
      :loading.sync="loading"
      :head-text="$t('documents.choose-folder')"
      :confirm-button="{
        text: $t('documents.copy'),
        icon: 'mdi-content-copy'
      }"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      :destinations="folders"
      destination-label="documents.folder"
      permission="document.update"
      dispatch="documentStore/massCopy"
      :on-success="updateDocumentList"
      permissions-item-key="_folder"
    ></DialogForMassOperators>
    <DialogForMassExport
      :dialog.sync="dialogExport"
      :loading.sync="loading"
      :selected.sync="selected"
      permission="document.read"
      :on-success="updateDocumentList"
      permissions-item-key="_folder"
    ></DialogForMassExport>
    <DialogForMassOperators
      :dialog.sync="dialogDelete"
      :loading.sync="loading"
      :head-text="$t('documents.delete-title')"
      :content-text="$t('documents.delete-dialog')"
      :confirm-button="{
        text: $t('documents.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      permission="document.delete"
      dispatch="documentStore/deleteList"
      :on-success="updateDocumentList"
      permissions-item-key="_folder"
    ></DialogForMassOperators>
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("documents.documents") }}</v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="item in menu"
          :key="item.title"
          :to="item.to"
          text
          color="primary"
          :disabled="item.disabled"
          v-on:click="item.onClick()"
          ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
        >
      </v-toolbar-items>
      <v-menu class="hidden-md-and-up">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="primary" class="hidden-md-and-up">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-for="item in menu" :key="item.title + '-menu'" dense>
            <v-btn
              :to="item.to"
              text
              color="primary"
              :disabled="item.disabled"
              v-on:click="item.onClick()"
              ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col class="py-0">
      <SearchDocument></SearchDocument>
      <!--    Sub Fields start-->
      <v-row style="align-items: baseline">
        <v-col cols="12" class="submenu py-0">
          <v-row
            class="py-0"
            style="align-items: center"
            v-if="type_id === 'letter'"
          >
            <v-col cols="12" sm="3">
              <v-select
                clearable
                :label="$t('documents.status')"
                v-model="subFilters.Status"
                :items="statuses"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            class="py-0"
            style="align-items: center"
            v-if="type_id === 'consumption-receipt'"
          >
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="subFilters.System"
                :label="$t('documents.system')"
                hide-details
                clearable
                class="pa-0 ma-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="subFilters.Object"
                :label="$t('documents.object')"
                hide-details
                clearable
                class="pa-0 ma-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                clearable
                :label="$t('documents.status')"
                v-model="subFilters.Status"
                :items="statuses"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            class="py-0"
            style="align-items: center"
            v-if="type_id === 'consumption-bill'"
          >
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="subFilters.System"
                :label="$t('documents.system')"
                hide-details
                clearable
                class="pa-0 ma-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="subFilters.Object"
                :label="$t('documents.object')"
                hide-details
                clearable
                class="pa-0 ma-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                clearable
                :label="$t('documents.status')"
                v-model="subFilters.Status"
                :items="statuses"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-col>
            <v-col cols="6" sm="3">
              <DateInput
                :date="subFilters.Date.from"
                @update="setDateFrom"
                :label="$t('documents.date-from')"
              ></DateInput>
            </v-col>
            <v-col cols="6" sm="3">
              <DateInput
                :date="subFilters.Date.to"
                @update="setDateTo"
                :label="$t('documents.date-to')"
              ></DateInput>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                v-model="subFilters.Amount.from"
                :label="$t('documents.amount-from')"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                v-model="subFilters.Amount.to"
                :label="$t('documents.amount-to')"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            class="py-0"
            style="align-items: center"
            v-if="type_id === 'service-invoice'"
          >
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="subFilters.Object"
                :label="$t('documents.object')"
                hide-details
                clearable
                class="pa-0 ma-0"
              ></v-text-field>
            </v-col>
            <v-col cols="7" sm="3">
              <v-select
                clearable
                :label="$t('documents.status')"
                v-model="subFilters.Status"
                :items="statuses"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-col>
            <v-col cols="5" sm="3">
              <v-checkbox
                v-model="OverDue"
                :label="$t('documents.over-due')"
                color="primary"
              ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="3">
              <DateInput
                :date="subFilters.Date.from"
                @update="setDateFrom"
                :label="$t('documents.date-from')"
              ></DateInput>
            </v-col>
            <v-col cols="6" sm="3">
              <DateInput
                :date="subFilters.Date.to"
                @update="setDateTo"
                :label="$t('documents.date-to')"
              ></DateInput>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                v-model="subFilters.Amount.from"
                :label="$t('documents.amount-from')"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                v-model="subFilters.Amount.to"
                :label="$t('documents.amount-to')"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="documentList"
      item-key="id"
      show-select
      :items-per-page="limit"
      hide-default-footer
      :custom-sort="customSort"
      :sort-by="ordersName"
      :sort-desc="ordersIsDesc"
      :loading="loading"
      :loading-text="$t(`tables.loading`)"
      no-data-text=""
      :height="isEmpty ? undefined : '100%'"
      :fixed-header="true"
      dense
      class="data-table"
    >
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.id="{ item }">
        <router-link
          :to="{
            name: 'Document',
            params: {
              id: item.id
            }
          }"
          v-if="hasPermissions(item._folder, 'document.read')"
        >
          {{ item.id }}
        </router-link>
        <template v-else>{{ item.id }}</template>
      </template>
      <template v-slot:item.created_at="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ getHumanDate(item.created_at) }} </span>
          </template>
          <span>{{ $dateTime(new Date(item.created_at), "long") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.updated_at="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ getHumanDate(item.updated_at) }} </span>
          </template>
          <span>{{ $dateTime(new Date(item.updated_at), "long") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:footer>
        <TableEmptyFooter v-if="isEmpty"></TableEmptyFooter>
      </template>
    </v-data-table>
    <v-divider />
    <v-col cols="12" v-if="documentList && documentList.length" class="py-0">
      <v-row>
        <v-col cols="12" sm="6" md="9" class="py-0">
          <v-pagination
            v-model="currentPage"
            :length="page.last"
            :total-visible="10"
            v-if="page.last > 1"
            class="smaller"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="py-0 hidden-sm-and-down">
          <p align="right" class="smaller" style="margin: 0">
            {{ $t("tables.rows-per-page") }}
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="my-2" v-on="on" height="32">{{ limit }}</v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, i) in limits"
                  :key="i"
                  @click="
                    () => {
                      limit = item;
                    }
                  "
                  :to="{
                    name: 'Documents',
                    query: {
                      ...$route.query,
                      limit_documents: i,
                      document_page: 1
                    }
                  }"
                  :class="{
                    'v-list-item--active': item === limit,
                    smaller: true
                  }"
                  exact
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-col>
</template>
<script>
import { rules } from "./../components/mixins/rules";
import { permissions } from "./../components/mixins/permissions";
import DialogForMassUpdate from "../components/documents/DialogForMassUpdate";
import DialogForMassOperators from "../components/common/dialogs/DialogForMassOperators";
import DialogForMassExport from "../components/documents/DialogForMassExport";
import CommonDialog from "../components/common/dialogs/CommonDialog";
import DateInput from "../components/common/inputs/DateInput";
import SearchDocument from "../components/common/tables/SearchDocument";
import TableEmptyFooter from "../components/common/tables/TableEmptyFooter";
import debounce from "../assets/js/debounce";
import { title } from "../components/mixins/title";
import moment from "moment";
export default {
  name: "Documents",
  mixins: [rules, permissions, title],
  components: {
    CommonDialog,
    DialogForMassOperators,
    DateInput,
    SearchDocument,
    TableEmptyFooter,
    DialogForMassUpdate,
    DialogForMassExport
  },
  data: function() {
    let limits = {
      25: 25,
      50: 50,
      100: 100,
      200: 200
    };
    return {
      selected: [],
      headers: [
        {
          text: this.$i18n.t("documents.id"),
          align: "left",
          value: "id",
          sortable: false
        },
        {
          text: this.$i18n.t("documents.name"),
          value: "name"
        },
        {
          text: this.$i18n.t("documents.created-at"),
          value: "created_at"
        },
        {
          text: this.$i18n.t("documents.updated-at"),
          value: "updated_at",
          align: "right"
        }
      ],
      currentPage: +this.$route.query.document_page || 1,
      folder: this.$route.query.folder || "",
      dialogMove: false,
      dialogCopy: false,
      dialogExport: false,
      dialogDeleteOne: false,
      dialogDelete: false,
      dialogUpdate: false,
      documentToDelete: null,

      destinationFolderId: null,
      destinationError: "",

      limit: limits[this.$route.query.limit_documents] || 25,
      limits,
      orders: this.$route.query.orders || "",
      loading: false,
      subFilters: {
        Title: this.$route.query.Title,
        Status: this.$route.query.Status,
        System: this.$route.query.System,
        Object: this.$route.query.Object,
        Date: {
          from: this.$route.query.Date_from,
          to: this.$route.query.Date_to
        },
        Amount: {
          from: this.$route.query.Amount_from,
          to: this.$route.query.Amount_to
        }
      }
    };
  },
  computed: {
    isEmpty() {
      return !(this.documentList && this.documentList.length) && !this.loading;
    },
    page: {
      get() {
        return this.$store.getters["documentStore/getPage"];
      }
    },
    types: {
      get() {
        return this.$store.getters["documentTypeStore/getList"];
      }
    },
    type() {
      return this.$route.query.type;
    },
    search() {
      return this.$route.query.search;
    },
    type_id() {
      return (this.types.find(i => i.id === this.type) || {}).id;
    },
    statuses() {
      let currentType = this.types.find(i => i.id === this.type);
      if (!currentType) return [];
      return currentType.statuses;
    },

    documentList: {
      get() {
        return this.$store.getters["documentStore/getList"];
      }
    },
    folders: {
      get() {
        return this.$store.getters["folderStore/getList"];
      }
    },
    isSomeSelectedCanBeDelete() {
      return !!this.selected.find(i =>
        this.hasPermissions(i._folder, "document.delete")
      );
    },
    isSomeSelectedCanBeMove() {
      return !!this.selected.find(i =>
        this.hasPermissions(i._folder, "document.update")
      );
    },
    isSomeSelectedCanBeCopy() {
      return !!this.selected.length;
    },
    isAllSelectedInOneType() {
      return (
        !!this.selected.length &&
        this.selected.filter(
          i => i._template._type.id === this.selected[0]._template._type.id
        ).length === this.selected.length
      );
    },
    ordersName() {
      if (this.orders) {
        return this.orders.split(":")[0];
      } else {
        return "";
      }
    },
    ordersIsDesc() {
      if (this.orders) {
        return this.orders.split(":")[1] === "desc";
      }
      return false;
    },
    menu() {
      let vm = this;
      return [
        {
          title: this.$t("documents.move"),
          to: null,
          onClick: function() {
            vm.dialogMove = true;
          },
          disabled: !this.isSomeSelectedCanBeMove,
          icon: "mdi-arrow-expand-right"
        },
        {
          title: this.$t("documents.copy"),
          to: null,
          onClick: function() {
            vm.dialogCopy = true;
          },
          disabled: !this.isSomeSelectedCanBeCopy,
          icon: "mdi-content-copy"
        },
        {
          title: this.$t("documents.export"),
          to: null,
          onClick: function() {
            vm.dialogExport = true;
          },
          disabled: !this.isSomeSelectedCanBeCopy,
          icon: "mdi-download-outline"
        },
        {
          title: this.$t("documents.update"),
          to: null,
          onClick: function() {
            vm.dialogUpdate = true;
          },
          disabled: !this.isAllSelectedInOneType,
          icon: "mdi-pencil"
        },
        {
          title: this.$t("documents.delete"),
          to: null,
          onClick: function() {
            vm.dialogDelete = true;
          },
          disabled: !this.isSomeSelectedCanBeDelete,
          icon: "mdi-trash-can-outline"
        }
      ];
    },
    getParams() {
      return ` ${this.$route.query.folder}
                ${this.$route.query.document_page}
                ${this.$route.query.search}
                ${this.$route.query.limit_documents}
                ${this.$route.query.orders}
                ${this.$route.query.type}
                ${this.$route.query.draft}
                ${this.$route.query.Title}
                ${this.$route.query.Status}
                ${this.$route.query.System}
                ${this.$route.query.Object}
                ${this.$route.query.Date_from}
                ${this.$route.query.Date_to}
                ${this.$route.query.Amount_from}
                ${this.$route.query.Amount_to}`;
    },
    today() {
      let date = new Date();
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    },
    OverDue: {
      get() {
        return this.subFilters.Date.to === this.today;
      },
      set() {
        this.setDateTo(
          this.subFilters.Date.to === this.today ? "" : this.today
        );
      }
    }
  },
  watch: {
    currentPage(val) {
      this.$router.push({
        name: "Documents",
        query: { ...this.$route.query, document_page: val }
      });
    },
    subFilters: {
      handler: function(obj) {
        let params = { ...this.$route.query };
        for (let prop in obj) {
          if (
            obj.hasOwnProperty(prop) &&
            typeof obj[prop] === "object" &&
            obj[prop]
          ) {
            for (var prop1 in obj[prop]) {
              params[`${prop}_${prop1}`] = obj[prop][prop1];
            }
          } else {
            params[prop] = obj[prop];
          }
        }
        for (let propName in params) {
          if (!params[propName]) {
            delete params[propName];
          }
        }
        this.$router
          .push({
            name: "Documents",
            query: params
          })
          .catch(() => {});
      },
      deep: true
    },
    getParams: function() {
      this.updateParams();
    }
  },
  methods: {
    setDateFrom(value) {
      this.$set(this.subFilters.Date, "from", value);
    },
    setDateTo(value) {
      this.$set(this.subFilters.Date, "to", value);
    },
    updateParams() {
      this.selected = [];
      this.folder = this.$route.query.folder || "";
      this.currentPage = +this.$route.query.document_page || 1;
      this.orders = this.$route.query.orders || "";
      this.draft = this.$route.query.draft || "";
      this.limit = this.limits[this.$route.query.limit_documents] || 25;
      this.subFilters = {
        Title: this.$route.query.Title,
        Status: this.$route.query.Status,
        System: this.$route.query.System,
        Object: this.$route.query.Object,
        Date: {
          from: this.$route.query.Date_from,
          to: this.$route.query.Date_to
        },
        Amount: {
          from: this.$route.query.Amount_from,
          to: this.$route.query.Amount_to
        }
      };
      this.startQuery();
    },
    resetSubFilters() {
      this.subFilters = {
        Title: null,
        Status: null,
        System: null,
        Object: null,
        Date: {
          from: null,
          to: null
        },
        Amount: {
          from: null,
          to: null
        }
      };
    },
    updateDocumentList() {
      this.selected = [];
      let orders = "";
      if (this.orders) {
        orders += this.ordersName;
        orders += ":" + (this.ordersIsDesc ? "desc" : "asc");
      }
      this.loading = true;

      let params = {
        orders,
        page: this.currentPage,
        limit: this.limit,
        filters: {
          folder: this.folder,
          "id;name": this.search,
          document_type: this.type,
          status: this.subFilters.Status
        },
        "content-filters": {
          Title: this.subFilters.Title,
          "ProjectAddress;ProjectZip;ProjectTown": this.subFilters.System,
          Object: this.subFilters.Object,
          DueDate: this.subFilters.Date,
          "Subtotal;BalanceOutstanding;Total": this.subFilters.Amount
        }
      };
      if (this.draft === "only") {
        params.filters.draft = "true";
      }
      if (this.draft === "without") {
        params.filters.draft = "false";
      }

      this.$store.dispatch("documentStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    startQuery: debounce(function() {
      this.updateDocumentList();
    }, 500),
    setDocumentToDelete(document = null) {
      this.documentToDelete = document;
      this.dialogDeleteOne = !!document;
    },
    deleteDocument() {
      this.dialogDeleteOne = false;
      this.loading = true;
      this.documentToDelete.isWillRemoveSoon = true;
      this.$store.dispatch("documentStore/delete", {
        id: this.documentToDelete.id,
        onSuccess: () => {
          this.selected = this.selected.filter(
            i => i.id !== this.documentToDelete.id
          );
          this.updateDocumentList();
          this.setDocumentToDelete();
        },
        onError: () => {
          this.documentToDelete.isWillRemoveSoon = false;
          this.setDocumentToDelete();
        }
      });
    },
    customSort(items, index, isDesc) {
      if (index && index[0]) {
        let newOrders = index[0] + ":" + (isDesc[0] ? "desc" : "asc");
        if (newOrders !== this.$route.query.orders)
          this.$router.push({
            name: "Documents",
            query: {
              ...this.$route.query,
              orders: newOrders
            }
          });
      } else {
        let query = { ...this.$route.query };
        if (query.orders) {
          delete query.orders;
          this.$router.push({
            name: "Documents",
            query
          });
        }
      }
      return items;
    },
    updateSelected(val) {
      this.$set(this.$data, "selected", val);
    },
    getArgumentForTitle() {
      return { chain: [this.$t("documents.documents")] };
    },
    getHumanDate(date) {
      moment.locale(this.$i18n.locale);
      return moment(date).fromNow();
    }
  },
  mounted() {
    this.updateDocumentList();
    this.$store.dispatch("documentTypeStore/getList", { limit: -1 });
  }
};
</script>
<style lang="scss" scoped>
.no-break {
  white-space: nowrap;
}
.smaller {
  transform: scale(0.8, 0.8);
}
.get-lower {
  margin-top: 25px;
}
.data-table::v-deep td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.data-table.theme--light.v-data-table::v-deep
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: rgb(225, 74, 74);
}
.submenu {
  padding-bottom: 0;
  padding-top: 0;
  &:empty {
    display: none;
    & + .reset {
      display: none;
    }
  }
  &::v-deep .col {
    padding-bottom: 0;
    padding-top: 0;
  }
  &::v-deep .row {
    padding-bottom: 0;
    padding-top: 0;
  }
  &::v-deep .v-input {
    padding: 0;
    margin: 0;
    .v-input__slot {
      margin: 0;
    }
    .v-text-field__details {
      min-height: 0;
      height: 0;
    }
    .v-messages {
      min-height: 0;
      height: 0;
    }
  }
}
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreen .data-table {
  flex: 1 1 100%;
  overflow: hidden;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
.fullScreenMobile::v-deep .v-data-table__mobile-row {
  height: auto;
  .v-data-table__mobile-row__wrapper {
    align-items: flex-start;
    padding-top: 3px;
    padding-bottom: 3px;
  }
}
.fullScreenMobile::v-deep .v-data-table-header-mobile th {
  padding-right: 0;
  padding-left: 12px;
  .v-data-table-header-mobile__wrapper {
    flex-direction: row-reverse;
  }
  div.active .v-data-table-header__icon {
    opacity: 1;
  }
}
.fullScreen .v-input--selection-controls__ripple {
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
